<template>
  <div id="app">
    <router-view />
    <div
      v-if="isOverlayOpen"
      id="globalOverlay"
      :class="`tw-fixed tw-w-full tw-h-screen tw-z-[3] tw-left-0 tw-top-0 overlay ${
        overlayLanding ? 'screen-overlay' : ''
      }`"
      @click="closeMenu"
    />
    <GlobalModal />
    <GlobalToastMessage />
  </div>
</template>
<script lang="ts">
import { Ref, defineComponent, ref } from "vue";
import store from "./store";
import EventEmitter, { EmitterEvents } from "./utils/eventEmitter";
import { IToastMessage } from "@/interfaces/common/IToastMessage";
import GlobalModal from "./components/common/globalModal.vue";
import GlobalToastMessage from "./components/common/globalToastMessage.vue";
import {
  OVERLAY_KEYBOARD,
  localStorageBoolean,
  localStorageKey,
  routers,
} from "@/utils/constants";
import { productFruits } from "product-fruits";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  components: {
    GlobalModal,
    GlobalToastMessage,
  },

  data() {
    return {
      toast: ref({}) as Ref<IToastMessage>,
    };
  },

  computed: {
    isOverlayOpen() {
      return store.state.Overlay.visible;
    },
    overlayKeyBoard() {
      return store.state.keyBoard.enter;
    },
    orgDetails() {
      return store.state.Org.currentOrg;
    },
    overlayLanding() {
      const route = useRoute();

      return (
        route.path === routers.shareProfile &&
        store.state.Navigation.chevronActive &&
        store.state.Overlay.isOverlayLandingPage
      );
    },
  },

  mounted() {
    const currentUserString = localStorage.getItem(
      localStorageKey.currentUserData,
    );
    if (!currentUserString) return;
    const currentUser = JSON.parse(
      localStorage.getItem(localStorageKey.currentUserData) || "",
    );
    const languageId = localStorage.getItem(localStorageKey.languageId);
    (window as any).productFruits?.services?.destroy();
    productFruits.init(
      process.env.VUE_APP_PRODUCT_FRUIT_WORDSPACE_CODE || "",
      Utils.getISOLanguageCode(languageId ?? currentUser?.languageId),
      {
        username: `${currentUser.firstName} ${currentUser.lastName}`,
      },
    );
    localStorage.setItem(
      localStorageKey.productFruitsInitialized,
      localStorageBoolean.true,
    );
    this.loadRC3Script();
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },

  beforeCreate() {
    this.$store.commit("LanguagePicker/initialiseStore");
    this.$store.commit("User/initialise");
    this.$store.commit("Prospect/initialise");
    this.$store.commit("Navigation/initialise");
    this.$store.commit("Assessment/INITIALISE");
    this.$store.commit("Recommend/INITIALISE");
    this.$store.commit("Vendor/INITIAL");
  },

  created() {
    this.eventListenerKeyBoard();
  },

  beforeUnmount() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange,
    );
    this.clearEventListenerKeyBoard();
  },

  methods: {
    closeMenu() {
      EventEmitter.emit(
        EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
        false,
      );
    },

    eventListenerKeyBoard() {
      document.addEventListener("keydown", (e) => {
        // if (e.key === "Enter") e.preventDefault();
        if (this.overlayKeyBoard === OVERLAY_KEYBOARD.MODAL) {
          if (e.key === "Enter")
            EventEmitter.emit(EmitterEvents.EVENT_KEYBOARD_ENTER);
        }
        if (e.key === "Escape")
          EventEmitter.emit(EmitterEvents.EVENT_KEYBOARD_ESC);
      });
    },

    clearEventListenerKeyBoard() {
      document.removeEventListener("keydown", () => {});
    },

    async loadRC3Script() {
      await Utils.getV3Recaptcha().then(async (finalKey: any) => {
        localStorage.removeItem("csrfReloadDone");
        const captchKey = finalKey;
        await load(`${captchKey}`, {
          autoHideBadge: true,
        });
      });
    },

    handleVisibilityChange() {
      const orgDataString = localStorage.getItem(
        localStorageKey.currentOrgData,
      );
      if (!orgDataString) return;

      const orgData = JSON.parse(orgDataString);
      const orgState = this.orgDetails;
      if (document.visibilityState !== "visible" || orgData?.id === orgState.id)
        return;

      const currentPath = this.$route.path;
      const pathRedirects = [
        {
          match: (path: string) => path === routers.assessChecklist,
          redirect: routers.assessCreate,
        },
        {
          match: (path: string) => path.includes("assess/vendor/review"),
          redirect: routers.assessVendor,
        },
        {
          match: (path: string) => path.includes("settings/team/roles/manage"),
          redirect: routers.settingTeamRoles,
        },
        {
          match: (path: string) => path.includes("assess/vendor/template"),
          redirect: routers.assessVendor,
        },
      ];

      for (const { match, redirect } of pathRedirects) {
        if (match(currentPath)) {
          this.$router.push({ path: redirect });
          setTimeout(() => window.location.reload(), 1000);
          return;
        }
      }

      window.location.reload();
    },
  },
});
</script>

<style scoped>
.overlay {
  background: rgb(0, 0, 0, 0.5);
}

.screen-overlay {
  height: calc(100vh - 14px) !important;
}
</style>
